var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"presence-absence"},[_c('sickness-reports',{attrs:{"is-loading-presence-state":_vm.isLoadingPresenceState}}),_vm._v(" "),_c('vacation-announcements'),_vm._v(" "),_c('vacation-registrations')],1)}
var staticRenderFns = []

export { render, staticRenderFns }